import { RootState } from "@store";
import { resetScroll } from "@store/minersSelect/actions";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const useMinerChangeControl = (id: number) => {
  const needChange = useSelector(
    (state: RootState) => state.minersSelect.scrollToMinerID === id
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (needChange) {
      const time = setTimeout(() => dispatch(resetScroll()), 800);
      return () => clearTimeout(time);
    }
  }, [needChange]);

  return {
    changed: needChange,
  };
};

export default useMinerChangeControl;
